import CaptivateImageGridTwo from './CaptivateImageGridTwo';
import CaptivateImageGridThree from './CaptivateImageGridThree';
import CaptivateImageGridFour from './CaptivateImageGridFour';
import CaptivateImageGridFive from './CaptivateImageGridFive';
import CaptivateImageGridSix from './CaptivateImageGridSix';
import CaptivateImageGridSeven from './CaptivateImageGridSeven';
import CaptivateImageGridEight from './CaptivateImageGridEight';
import CaptivateLandscapeImage from './ImageOrientation/CaptivateLandscapeImg';

const CaptivateImageGridUI = ({
  type = 1,
  dataList = [],
  variation = 1,
  updateCarouselState = () => {},
}) => {
  if (!dataList.length) return null;

  const gridComponents = {
    1: CaptivateLandscapeImage,
    2: CaptivateImageGridTwo,
    3: CaptivateImageGridThree,
    4: CaptivateImageGridFour,
    5: CaptivateImageGridFive,
    6: CaptivateImageGridSix,
    7: CaptivateImageGridSeven,
    8: CaptivateImageGridEight,
  };

  const GridComponent = gridComponents[type] || null;

  return GridComponent ? (
    <GridComponent
      dataList={dataList}
      variation={variation}
      updateCarouselState={updateCarouselState}
    />
  ) : null;
};

export default CaptivateImageGridUI;
